import React from 'react';
import { Field } from 'react-final-form';
import { TextField } from '@mui/material';

const RFFTextField = ({ name, ...props }) => (
  <Field name={name}>
    {({ input, meta }) => (
      <TextField {...input} {...props} error={meta.touched && meta.error} helperText={meta.touched && meta.error} />
    )}
  </Field>
);

export default RFFTextField;
